import { ConfirmModal } from './ConfirmModal';
import { useForceLogout } from '../hooks';

interface Props {
  open: boolean;
  userId: string;
  userName?: string;
  onClose: () => void;
}

export function ForceLogoutModal({ open, userId, userName, onClose }: Props) {
  const mutation = useForceLogout();
  return (
    <ConfirmModal
      open={open}
      title={`Force logout ${userName ?? 'user'}?`}
      description="All active devices will be signed out and Firebase refresh tokens revoked."
      confirmLabel="Force logout"
      destructive
      loading={mutation.isPending}
      onClose={onClose}
      onConfirm={async () => {
        await mutation.mutateAsync(userId);
        onClose();
      }}
    >
      {mutation.error && (
        <p className="text-xs text-red-300">{(mutation.error as Error).message}</p>
      )}
    </ConfirmModal>
  );
}
